if (!customElements.get('sa-video-swiper')) {
  class SaCaseBox4 extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
      this.initScrollAnimation();
      // Setup video observer
      this.setupVideoObserver();
    }

    setupVideoObserver() {
      // Clean up existing observer if any
      if (this.videoObserver) {
        this.videoObserver.disconnect();
      }

      const options = {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0.1 // Play when at least 10% visible
      };

      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            // Video is visible -> Play
            video.play().catch(() => {});
          } else {
            // Video is hidden -> Pause
            video.pause();
          }
        });
      }, options);

      const videos = this.querySelectorAll('video');
      videos.forEach(video => {
        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        // Remove autoplay attribute to let observer handle it
        video.removeAttribute('autoplay');
        this.videoObserver.observe(video);
      });
    }

    async initSwiper() {
      if (!window.Swiper) {
        // Simple wait mechanism if Swiper isn't loaded yet
        let attempts = 0;
        const checkSwiper = setInterval(() => {
          attempts++;
          if (window.Swiper) {
            clearInterval(checkSwiper);
            this.initSwiperInstance();
          } else if (attempts > 50) {
            clearInterval(checkSwiper);
            console.error('Swiper not found');
          }
        }, 100);
        return;
      }
      this.initSwiperInstance();
    }

    initSwiperInstance() {
      const swiperContainer = this.querySelector('.swiper');
      if (!swiperContainer) return;

      this.swiper = new window.Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        navigation: {
          nextEl: '.sa-video-swiper__next',
          prevEl: '.sa-video-swiper__prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 2,
          }
        },
        on: {
          init: () => {
            // Re-setup observer after Swiper init to catch cloned slides
            setTimeout(() => this.setupVideoObserver(), 100);
          }
        }
      });
    }

    // initVideoControls removed as requested
    /*
    initVideoControls() {
       ...
    }
    */

    initScrollAnimation() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.add('is-visible');
            observer.disconnect();
          }
        });
      }, { threshold: 0.2 });
      observer.observe(this);
    }

    disconnectedCallback() {
      // Cleanup
      if (this.swiper) {
        this.swiper.destroy();
      }
      // Remove listeners? (Automatic with element removal mostly, but good practice)
    }
  }
  customElements.define('sa-video-swiper', SaCaseBox4);
}
